let maskEl;
class UiCommon {
    static mask({fatherEl=document.body,color='transparent'}){
        if(this.isHasMask())
        {
            return;
        }
        let mask = document.createElement("div");
        mask.id='maskBg'
        mask.style.cssText=` background-color: ${color};
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width:100%;
        z-index:800;
        transition: transform .3s ease-in-out,opacity .3s ease-in-out,-webkit-transform .3s ease-in-out;
        `
        const  maskBg = document.getElementById("maskBg");
        if(!maskBg){
            fatherEl.appendChild(mask);
            maskEl = mask;
        }
        return mask;
    }
    static deleteMask({async=false}){
        if(!maskEl)return;
        if(async){
            setTimeout(()=>{
                maskEl && maskEl.parentNode.removeChild(maskEl);
                maskEl=null;
            },200)
        }else{
            maskEl.parentNode.removeChild(maskEl);
            maskEl=null;
        }
    }
    static isHasMask()
    {
        if(maskEl)
        {
            return true;
        }
        return false;
    }
}

export default UiCommon;